<template>
    <a-modal title="导入文件" :visible="true" :footer="false" :width="600" @cancel='layerCancel'>
        <div>
            <a href="javascript:;" @click="downFile">导入模板文件下载</a>
            <div style="margin-top: 10px;">
                <a-upload
                    accept=".xlsx, .xls"
                    ref="uploads"
                    name="file"
                    class="avatar-uploader"
                    :customRequest="customRequest"
                    :multiple="false"
                    :showUploadList="false"
                    :headers="headers"
                    >
                    <a-button>
                        <a-icon type="upload" />
                        选择导入文件
                    </a-button>
                </a-upload>
            </div>
        </div>
    </a-modal>
</template>
<script>
import {inputFileData, findModuleFile} from '@/api/keyPart';
import { getToken, setselectNearest } from "@/utils/auth";

export default {
  props:{
    id: Number,
  }, 
  data() {
    return {
        doUpload: "/api/certificate/keyPieceModel/excelImport/", //上传文件api
        headers: {},
        exportStatus: true, // 是否可以下载
    }
  },
  watch: {
    
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.doUpload = '/api/certificate/keyPieceModel/excelImport/' + this.id;
      let token = getToken();
      this.headers.Authorization = "Bearer " + token; //上传文件绑定Token  ie10以下不能使用
    },
    layerCancel() {
      this.$emit('hideAction');
    },
    downFile() {
        if (this.exportStatus) {
            this.exportStatus = false;
            this.$message.success('模板下载中，请稍后...');
            findModuleFile()
            .then(res => {
                const content = res;
                const blob = new Blob([res], {type: "application/vnd.ms-excel"});
                const fileName = '证书在用型号导入模板.xls'
                //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
                //IE10以上支持blob但是依然不支持download
                if ('download' in document.createElement('a')) { //支持a标签download的浏览器
                    const link = document.createElement('a'); //创建a标签
                    link.download = fileName; //a标签添加属性
                    link.style.display = 'none';
                    link.href = URL.createObjectURL(blob);
                    document.body.appendChild(link);
                    link.click();//执行下载
                    URL.revokeObjectURL(link.href); //释放url
                    document.body.removeChild(link);//释放标签
                } else { //其他浏览器
                    navigator.msSaveBlob(blob, fileName);
                }
                setTimeout(() => {
                    this.exportStatus = true;
                }, 1000);
            })
            .catch(error => {
                this.exportStatus = true;
                console.log(error);
            })
        } else {
            this.$message.warning('正在下载中，请勿重复操作！');
        }
    },
    customRequest(data) {
        const formData = new FormData();
        formData.append('file', data.file)
        inputFileData(this.id, formData)
            .then((res) => {
                this.downFileData(res);
                this.$message.success('文件导入成功，导入结果已自动下载');
            })
            .catch(error => {
                this.$message.success('文件导入失败');
                console.log(error);
            })
    },
    downFileData(res) {
        const content = res;
        const blob = new Blob([res], {type: "application/vnd.ms-excel"});
        const fileName = '导入结果.xls'
        //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        //IE10以上支持blob但是依然不支持download
        if ('download' in document.createElement('a')) { //支持a标签download的浏览器
            const link = document.createElement('a'); //创建a标签
            link.download = fileName; //a标签添加属性
            link.style.display = 'none';
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.click();//执行下载
            URL.revokeObjectURL(link.href); //释放url
            document.body.removeChild(link);//释放标签
            this.$emit('sucAction');
        } else { //其他浏览器
            navigator.msSaveBlob(blob, fileName);
            this.$emit('sucAction');
        }
    }
  },
}
</script>
<style lang="less" scoped>
   
</style>